import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks';
import { PortalHeader } from '../components';

export const PortalLayout = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="dashboard-loading">
        <div className="spinner spinner-lg" />
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="portal-layout">
      <PortalHeader />
      <main className="portal-main">
        <Outlet />
      </main>
    </div>
  );
};

export default PortalLayout;
